module.exports = __webpack_public_path__ + "img/225.d90fd751.jpg";